import * as React from "react";
import { BaseComponent } from "../../../../react-core/Html/BaseComponent";
import { IStepConfig, StepType } from "./Process";
import * as classNames from "classNames";
import { ProcessSubStepper } from "./ProcessSubStepper";

export interface IProcessStepperProps extends React.Props<ProcessStepper> {
    currentStep: number;
    config: IStepConfig[];
    onStepLeave: (from: number, to: number) => void;
    canSwitchStep: boolean;
}

export interface ISubSteppersConfig {
    title: string;
    subSteppers: IStepConfig[];
}

export interface IProcessStepperState { }

export class ProcessStepper extends BaseComponent<IProcessStepperProps, IProcessStepperState> {
    constructor(props: any) {
        super(props);
    }

    private formatSteppers(configs: IStepConfig[]) {
        const formatedSteppers = [];
        configs.forEach((ele) => {
            if (!ele.group) {
                formatedSteppers.push(ele);
            } else {
                const pStepIndex = formatedSteppers.findIndex((old) => old.title == ele.group);
                if (pStepIndex > -1) {
                    formatedSteppers[pStepIndex].subSteppers.push(ele);
                } else {
                    formatedSteppers.push({ title: ele.group, subSteppers: [ele] });
                }
            }
        });
        return formatedSteppers;
    }

    private onClickStep(from: number, to: number) {
        if (!this.props.canSwitchStep) {return;}
        this.props.onStepLeave(from, to);
    }

    public render(): JSX.Element {
        const formattedSteppers = this.formatSteppers(this.props.config);
        let count = 0;
        return (
            <div className="wizard-stepper no-print">
                <ul className="steps">
                    {formattedSteppers.map((wizardstep, index) => {
                        if (wizardstep.type && wizardstep.type == StepType.Extra) {
                            count += 1;
                            return null;
                        }
                        if (!wizardstep.component) {
                            count = count + wizardstep.subSteppers.length;
                            return (
                                <ProcessSubStepper
                                    key={`subStepper-${index}`}
                                    currentStep={this.props.currentStep}
                                    config={wizardstep}
                                    canSwitchStep={this.props.canSwitchStep}
                                    endIndex={count}
                                    onStepLeave={(from, to) => this.props.onStepLeave(from, to)}
                                />
                            );
                        }

                        let classes = classNames(
                            { current: this.props.currentStep == count },
                            { done: this.props.currentStep > count }
                        );
                        if (wizardstep.type == StepType.Confirmation) {
                            classes = null;
                        }
                        if (wizardstep.title == "Quote ready" && this.props.currentStep >= count) {
                            classes = classNames({ done: true });
                        }
                        count += 1;
                        return (
                            <li key={index} className={classes}>
                                <div className="ws-1-link"
                                    onClick={() => this.onClickStep(this.props.currentStep, index)}
                                >
                                    {wizardstep.title}
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}
